export function logisticsReducer(state, action) {
    switch (action.type) {
        //#region Normal Filters
        case "setReceiptDate":
            return {
                ...state,
                receiptDate: action.payload
            }

        case "setVendorShipmentNo":
            return {
                ...state,
                vendorShipmentNo: action.payload
            }

        case "setSenderName":
            return {
                ...state,
                senderName: action.payload
            }

        case "setSchoolNumber":
            return {
                ...state,
                schoolNumber: action.payload
            }

        case "setLinesLinkedSelected":
            return {
                ...state,
                linesLinkedSelected: action.payload
            }

        case "setLogisticsSavedSelected":
            return {
                ...state,
                logisticsSavedSelected: action.payload
            }
        //#region

        //#region Page hidden filters
        case "setReturnMarkValue":
            return {
                ...state,
                returnMarkValue: action.payload
            }

        case "setBarcodeIsLinked":
            return {
                ...state,
                barcodeIsLinked: action.payload
            }

        case "setBarcodeNotLinkedTabNumber":
            return {
                ...state,
                barcodeNotLinkedTabNumber: action.payload
            }

        case "barcodeIsLinked":
            return {
                ...state,
                barcodeIsLinked: true,
                disabled: 0,
                vendorShipmentNo: "",
            }

        case "barcodeIsNotLinked":
            return {
                ...state,
                barcodeIsLinked: false,
                disabled: 0,
                vendorShipmentNo: "",
            }

        case "extraReceipts":
            return {
                ...state,
                barcodeIsLinked: false,
                disabled: 0,
                vendorShipmentNo: "EXTRA",
            }

        case "disabled":
            return {
                ...state,
                barcodeIsLinked: false,
                disabled: 1,
                vendorShipmentNo: "",
            }
        //#region

        //#region Paginator
        case "setPageSize":
            return {
                ...state,
                pageSize: action.payload
            }

        case "setCurrentPage":
            return {
                ...state,
                currentPage: action.payload
            }
        //#endregion

        default:
            return state;
    }
}